import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
import {
    formatterTime
} from '@/util/util'



export const groupDetailOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: false,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "产品名称",
            prop: "goodsName",
            type: 'input',
            span: 18
        }, {
            label: "客户昵称",
            prop: "userName",
            type: 'input',
            span: 18
        }, {
            label: "客户账号",
            prop: "account",
            type: 'input',
            span: 18
        }, {
            label: "团购订单状态",
            prop: "status",
            search: true,
            type: 'select',
            dicData: DIC.PRODUCT_GROUP_ORDER_STATUS,
            span: 18
        },
        {
            label: "参团时间",
            prop: "orderTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "参团时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            search: true,
            hide: true,
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        },
        {
            label: "成团时间",
            prop: "groupTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        // {
        //     label: "更新人",
        //     prop: "createBy",
        //     type: "input",
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     width: "110"
        // },
    ]
};